<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">






<!--sidebar-->
<ItemSidebar :name="$store.state.flows.flow.name" 
:brand="$store.state.flows.flow.brand"
:project="$store.state.flows.flow.project"
:questionlist="$store.state.flows.flow.questionlist"
:educationpack="$store.state.flows.flow.educationpack"
:suppliercount="suppliercount"
:flow_type="$store.state.flows.flow.type"
></ItemSidebar>
<!--sidebar-->









<div class="col-12 md:col-10">
<div class="content_card_content">
<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
<SupplierUploadDialog></SupplierUploadDialog>
 </div> 
</template>

<script>
export default {

  name: 'Project',

  data () {
    return {
      item:null,
      tabs: [
            {
              title: 'durum',
              icon: 'chart-line',
              route: 'status',
          },
          {
              title: 'genel',
              icon: 'list',
              route: 'general',
          },
          {
              title: 'suppliers',
              icon: 'globe',
              route: 'suppliers',
          },
          {
              title: 'ceviriler',
              icon: 'info-circle',
              route: 'translations',
          },
          {
              title: 'otomasyon',
              icon: 'cog',
              route: 'conditions',
          },
      ],

    }
  },
  computed:{
    suppliercount()
    {
      return this.$store.state.projects.suppliers.length
    },
  },
  mounted()
  {
    
    this.getData()
    this.checkTabName(this.tabs)
  },
  methods:{
    
  	async getData()
    {
        let item = await this.generalApiGet("flow/"+this.$route.params.id)        
        
        if(this.$store.state.auth.userroles.includes("admin"))
        {
          {
          let the_obj = await {
            title:"is_bedelleri",
            icon: 'money-bill',
            route: 'business_return',
          }
          await this.tabs.push(the_obj)
        }
        }

        if(item.type=="education")
        {
          let the_obj = await {
            title:"egitim",
            icon: 'video',
            route: 'education',
          }
          await this.tabs.push(the_obj)
        }

        if(item.type=="self_evaluation")
        {

          let the_obj = await {
            title:"sonuc_ekranlari",
            icon: 'dashboard',
            route: 'result_displays',
            icon_type:'material'
          }

          await this.tabs.push(the_obj)

          the_obj = await {
            title:"self_evaluation",
            icon: 'check-circle',
            route: 'self_evaluation',
          }

          await this.tabs.push(the_obj)

        }
        if(item.type=="verification")
        {

          let the_obj = await {
            title:"sonuc_ekranlari",
            icon: 'dashboard',
            route: 'result_displays',
            icon_type:'material'
          }

          the_obj = await {
            title:"verification",
            icon: 'check-circle',
            route: 'verification',
          }
          await this.tabs.push(the_obj)
          the_obj = await {
            title:"uygunsuzluklar",
            icon: 'exclamation-circle',
            route: 'flow_nonconformities',
          }
          await this.tabs.push(the_obj)
          
        }

        if(item.type=="audit")
        {

          let the_obj = await {
            title:"sonuc_ekranlari",
            icon: 'dashboard',
            route: 'result_displays',
            icon_type:'material'
          }

          the_obj = await {
            title:"audit",
            icon: 'user-edit',
            route: 'audit',
          }
          await this.tabs.push(the_obj)
          the_obj = await {
            title:"uygunsuzluklar",
            icon: 'exclamation-circle',
            route: 'flow_nonconformities',
          }
          await this.tabs.push(the_obj)
        }
        await this.$store.dispatch('flows/setFlow',item) 
        this.item = await item
        for(let tab of this.tabs)
        {
          tab.route = await "/"+this.$store.state.auth.user.uuid+"/flow/"+this.$route.params.id+"/"+tab.route
        }
      await setTimeout(async ()=>{
        let suppliers = await this.generalApiGetWithoutLoader("flow/all_suppliers/"+this.$route.params.id)
        await this.$store.dispatch('flows/setSuppliers',suppliers)
      },100)
    }
  }
};
</script>

<style lang="css" scoped>
</style>